import SwaggerUI from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";

// var cors = new EnableCorsAttribute("*", "*", "*");
// config.EnableCors(cors);
// config.EnableCors(new EnableCorsAttribute(Properties.Settings.Default.Cors, "", ""))
// app.UseCors(CorsOptions.AllowAll);

// var cors =new EnableCorsAttribute(Properties.Settings.Default.Cors, "", "")
// config.EnableCors(cors);
// app.UseCors(CorsOptions.AllowAll);

SwaggerUI({
  dom_id: "#app",
  spec: require("./api.json")
});
